import React from "react";

const TLossModal = ({ onClose, onTalk, onNotNow }) => (
  <div className="modal show custom-modall" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header border-0">
          
          <button type="button" className="btn-close" onClick={onClose}></button>
        </div>
        <div className="modal-body text-center">
          <p style={{fontSize:"1.3rem"}}>We know how hard this journey can be. If you'd like to connect and talk with your WIN Nurse or Behavioral Health Advocate is here to support you.</p>
          <button
            className="win-btn-primary w-100 mb-2"
            onClick={onTalk}
          >
            Yes, I'd like to talk
          </button>
          <button
            className="win-btn-secondary w-100"
            onClick={onNotNow}
          >
            Not right now
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default TLossModal;
